import admin from "./admin";
import auth from "./auth";

const pages = {
  admin,
  auth
}

export default pages